import { render, staticRenderFns } from "./customBanner.vue?vue&type=template&id=67679d6d&scoped=true"
import script from "./customBanner.vue?vue&type=script&lang=js"
export * from "./customBanner.vue?vue&type=script&lang=js"
import style0 from "./customBanner.vue?vue&type=style&index=0&id=67679d6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67679d6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67679d6d')) {
      api.createRecord('67679d6d', component.options)
    } else {
      api.reload('67679d6d', component.options)
    }
    module.hot.accept("./customBanner.vue?vue&type=template&id=67679d6d&scoped=true", function () {
      api.rerender('67679d6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/index/customBanner.vue"
export default component.exports